module.exports = __webpack_public_path__ + "img/abacus_type_1 (old).a2ef8aa8.png";